export const CHECK_BOX_UPDATE_MODAL_ITEMS = 'CHECK_BOX_UPDATE_MODAL_ITEMS'

export const updateModalItems = payload => (dispatch, getState) => {
    dispatch({ type: CHECK_BOX_UPDATE_MODAL_ITEMS, payload })
}